
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BankAccount } from '../models/bank-account.model';
import { BillingAccount } from '../models/billing-account.model';
import { StatusResponse } from '../models/status-response.model';
import { SecureHttp } from '../helpers/securehttp';
import { BankInfo } from '../models/bank-info.model';
import { PagedResults } from '../models/paged-results.model';

@Injectable()
export class BankAccountsService {

    constructor(
        private http: HttpClient,
        private _secureHttp: SecureHttp
    ) { }

    query(account: string): Observable<BankAccount[]> {
        let url = `api/bank-accounts/all`;
        let params = new HttpParams();
        params = params.set('account', account);
        return this._secureHttp.get(url, { params: params }).pipe(map(response => response as BankAccount[]));
    }

    paged(options?: any): Observable<PagedResults<BankAccount>> {

        let url = `${environment.apiUrl}api/bank-accounts/paged`;
        let params: HttpParams = new HttpParams();

        if (options) {
            for (let key in options) {
                if (key && options[key]) {
                    params = params.set(key, options[key]);
                }
            }
        }

        return this._secureHttp.get(url, { params: params }).pipe(
            map(response => response as PagedResults<BankAccount>));
    }

    get(account: string, id: string): Observable<BankAccount> {
        let url = `${environment.apiUrl}api/bank-accounts/detail`;
        let params = new HttpParams();
        params =  params.set('account', account);
        params =  params.set('id', id);
        return this._secureHttp.get(url, { params: params }).pipe(map(response => response as BankAccount));
    }

    validateRoutingNumber(rn: string): Observable<BankInfo> {
        let url = `${environment.apiUrl}api/bank-accounts/validate-routing-number`;
        let params = new HttpParams();
        params = params.set('rn', rn);
        return this._secureHttp.get(url, { params: params }).pipe(map(response => response as BankInfo));
    }

    addOrUpdate(account: string, bankAccount: BankAccount): Observable<StatusResponse> {
        let url = `${environment.apiUrl}api/bank-accounts/addupdate`;
        let params = new HttpParams();
        params = params.set('account', account);
        return this._secureHttp.post(url, bankAccount, { params: params }).pipe(map(response => response as StatusResponse));
    }

    updateBA(account: string, billingAccount: BillingAccount): Observable<StatusResponse> {
        let url = `${environment.apiUrl}api/bank-accounts/updateba`;
        let params = new HttpParams();
        params = params.set('account', account);
        return this._secureHttp.put(url, billingAccount, { params: params }).pipe(map(response => response as StatusResponse));
    }

    delete(account: string, id: string): Observable<StatusResponse> {
        let url = `${environment.apiUrl}api/bank-accounts/remove`;
        let params = new HttpParams();
        params = params.set('account', account);
        params = params.set('id', id);
        return this._secureHttp.delete(url, { params: params }).pipe(map(response => response as StatusResponse));
    }
}